import { forwardRef } from 'react';
// @mui
import { Box } from '@mui/material';
//
import { STAGE, TYPE } from '../../../theme/stage';
import { MENU } from '../copy';
import { CSS_EASE, DURATION } from '../motion';

// ----------------------------------------------------------------------

type Props = {
  open: boolean;
  onClick: VoidFunction;
};

const LINE = {
  position: 'absolute',
  left: 0,
  width: 18,
  borderTop: '1.5px solid currentColor',
  transition: `transform 240ms ${CSS_EASE.press}`,
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
} as const;

const MenuButton = forwardRef<HTMLButtonElement, Props>(function MenuButton(
  { open, onClick },
  ref
) {
  return (
    <Box
      ref={ref}
      component="button"
      type="button"
      aria-expanded={open}
      aria-controls={open ? MENU.id : undefined}
      onClick={onClick}
      sx={{
        ...TYPE.button,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        height: 44,
        minWidth: 44,
        p: '0 14px',
        mr: '-10px',
        border: 0,
        borderRadius: '999px',
        bgcolor: 'transparent',
        color: STAGE.ink,
        cursor: 'pointer',
        transition: `background-color ${DURATION.hover}ms ${CSS_EASE.outExpo}`,
        '@media (hover: hover)': { '&:hover': { bgcolor: STAGE.surface2 } },
      }}
    >
      <Box component="span" sx={{ display: 'grid', '& > *': { gridArea: '1 / 1' } }}>
        <Box component="span" sx={{ visibility: open ? 'hidden' : undefined }}>
          {MENU.open}
        </Box>
        <Box component="span" sx={{ visibility: open ? undefined : 'hidden' }}>
          {MENU.close}
        </Box>
      </Box>
      <Box
        component="span"
        aria-hidden
        sx={{ position: 'relative', display: 'block', width: 18, height: 8 }}
      >
        <Box
          component="span"
          sx={{ ...LINE, top: 0, transform: open ? 'translateY(3.25px) rotate(45deg)' : 'none' }}
        />
        <Box
          component="span"
          sx={{
            ...LINE,
            bottom: 0,
            transform: open ? 'translateY(-3.25px) rotate(-45deg)' : 'none',
          }}
        />
      </Box>
    </Box>
  );
});

export default MenuButton;
